import React, { useEffect, useState, useRef } from 'react';
import './workoutsHeader.css';
import { useSelector, useDispatch } from "react-redux";
import {
    dropdownAction,
    filterCoachesOptionsAction,
    filterWorkoutsCountOptionsAction,
    filterConstraintsOptionsAction,
    filterDateAction,
    filterOneTimeWorkoutAction,
    filterDebtWorkoutsAction,
    filterTypesOptionsAction,
    filterUserAction,
    filterWindowAction,
    oneTimeWorkoutFormAction,
    resetAllFiltersAction
} from "../../../redux/rootReducer";
import {
    getUsersForSubscriptionSagaAction,
} from "../../../redux/sagaActions";
import { GetWorkoutsThunk } from "../../../redux/thunks/GetWorkoutsThunk";
import { ExportWorkoutsToExcelThunk } from "../../../redux/thunks/ExportWorkoutsToExcelThunk";
import FilterSelect from "../../FilterSelect/FilterSelect";
import Checkbox from "../../Checkbox/Checkbox";
import FiltersWrapper from "../../FiltersWrapper/FiltersWrapper";
import CalendarOffline from "../../CalendarOffline/CalendarOffline";
import { ONE_TIME_WORKOUT_FORM_INITIAL } from "../../../redux/initialStateConstant";

const WorkoutsHeader = () => {
    const dispatch = useDispatch();
    const filterDate = useSelector(state => state.filterDate);
    const filterUser = useSelector(state => state.filterUser);
    const dropdown = useSelector(state => state.dropdown);
    const subscription_types = useSelector(state => state.subscription_types);
    const subscription_coaches = useSelector(state => state.subscription_coaches);
    const subscription_constraints = useSelector(state => state.subscription_constraints);
    const subscription_workouts_count = useSelector(state => state.subscription_workouts_count);
    const filterTypesOptions = useSelector(state => state.filterTypesOptions);
    const filterCoachesOptions = useSelector(state => state.filterCoachesOptions);
    const filterConstraintsOptions = useSelector(state => state.filterConstraintsOptions);
    const filterWorkoutsCountOptions = useSelector(state => state.filterWorkoutsCountOptions);
    const filterOneTimeWorkout = useSelector(state => state.filterOneTimeWorkout);
    const filterDebtWorkouts = useSelector(state => state.filterDebtWorkouts);

    // Таймер для отсрочки запроса посетителей на сервере
    const timer = useRef(0);

    // Состояние календаря
    const [openFromCalendar, setOpenFromCalendar] = useState(false);
    const [openToCalendar, setOpenToCalendar] = useState(false);

    const getUsers = text => {

        if (timer.current) clearTimeout(timer.current);

        if (!text.trim()) {
            dispatch(filterUserAction({
                user: { id: '', name: '' },
                users: []
            }));
            return false;
        }

        // Делаем задержку для набора текста
        timer.current = setTimeout(() => {
            dispatch(getUsersForSubscriptionSagaAction({ text, type: 'filter' }));
        }, 500);
    };

    useEffect(() => {
        dispatch(filterTypesOptionsAction(subscription_types.map(elem => ({ ...elem, active: false }) )));
        dispatch(filterCoachesOptionsAction(subscription_coaches.filter(el => el.id).map(elem => ({ ...elem, active: false }) )));
        dispatch(filterConstraintsOptionsAction(subscription_constraints.filter(el => el.id).map(elem => ({ ...elem, active: false }))));
        dispatch(filterWorkoutsCountOptionsAction(subscription_workouts_count.filter(el => el.id).map(elem => ({ ...elem, active: false }))));
    }, [subscription_types, subscription_coaches, subscription_constraints, subscription_workouts_count]);

    return (
        <>
            <FiltersWrapper>
                <div className="flt__content">
                    <div className="flt__reset" onClick={ () => {
                        // Сброс фильтров
                        dispatch(resetAllFiltersAction());
                    } }>Сбросить фильтры</div>
                    <div className="flt__caption">Фильтры</div>
                    <div className="filter filter--calendar"
                         onClick={ event => {
                             event.preventDefault();
                             event.stopPropagation();
                             setOpenFromCalendar(!openFromCalendar);
                         } }
                    >
                        { `${ filterDate.from ? new Date(filterDate.from).toLocaleDateString('ru-Ru') : 'Дата с' }` }
                        {
                            filterDate.from
                                ? <div className="filter__remove" onClick={ event => {
                                    event.stopPropagation();
                                    dispatch(filterDateAction({ ...filterDate, from: '' }));
                                } } />
                                : false
                        }
                    </div>
                    <CalendarOffline
                        style={{ marginTop: 0 }}
                        date={ filterDate.from }
                        handler={ date => {
                            dispatch(filterDateAction({ ...filterDate, from: date }));
                            setOpenFromCalendar(false);
                        }}
                        open={ openFromCalendar }
                        close={ () => setOpenFromCalendar(false) }
                    />
                    <div className="filter filter--calendar"
                         onClick={ event => {
                             event.preventDefault();
                             event.stopPropagation();
                             setOpenToCalendar(!openToCalendar);
                         } }
                    >
                        { `${ filterDate.to ? new Date(filterDate.to).toLocaleDateString('ru-Ru') : 'Дата по' }` }
                        {
                            filterDate.to
                                ? <div className="filter__remove" onClick={ event => {
                                    event.stopPropagation();
                                    dispatch(filterDateAction({ ...filterDate, to: '' }));
                                } } />
                                : false
                        }
                    </div>
                    <CalendarOffline
                        style={{ marginTop: 0 }}
                        date={ filterDate.to }
                        handler={ date => {
                            dispatch(filterDateAction({ ...filterDate, to: date }));
                            setOpenToCalendar(false);
                        }}
                        open={ openToCalendar }
                        close={ () => setOpenToCalendar(false) }
                    />
                    <div className="select__wrapper">
                        <FilterSelect
                            options={ filterTypesOptions }
                            handler={ id => dispatch(filterTypesOptionsAction(filterTypesOptions.map(elem => {
                                // Меняем состояние выбранных элементов
                                if (elem.id === id) return { ...elem, active: !elem.active };
                                else return elem;
                            }))) }
                            placeholder={ 'Тип абонемента' }
                            open={ dropdown === 'filter_types' }
                            openHandler={ () => dispatch(dropdownAction('filter_types')) }
                            clear={ () => dispatch(filterTypesOptionsAction(filterTypesOptions.map(elem => {

                                if (elem.active) return { ...elem, active: !elem.active };
                                else return elem;
                            }))) }
                        />
                    </div>
                    <div className="select__wrapper">
                        <FilterSelect
                            options={ filterCoachesOptions }
                            handler={ id => dispatch(filterCoachesOptionsAction(filterCoachesOptions.map(elem => {
                                // Меняем состояние выбранных элементов
                                if (elem.id === id) return { ...elem, active: !elem.active };
                                else return elem;
                            }))) }
                            placeholder={ 'Тренер' }
                            open={ dropdown === 'filter_coaches' }
                            openHandler={ () => dispatch(dropdownAction('filter_coaches')) }
                            clear={ () => dispatch(filterCoachesOptionsAction(filterCoachesOptions.map(elem => {

                                if (elem.active) return { ...elem, active: !elem.active };
                                else return elem;
                            }))) }
                        />
                    </div>
                    <div className="dropdown">
                        <div className="filter filter--input">
                            <input className="filter__input"
                                   placeholder={ 'Посетитель' }
                                   value={ filterUser.user.name }
                                   onInput={ event => {
                                       dispatch(filterUserAction({
                                           ...filterUser,
                                           user: {
                                               id: '',
                                               name: event.target.value
                                           }
                                       }));
                                       // Получение с сервера списка всех пользователей, с совпадением по email или телефону
                                       getUsers(event.target.value);
                                   } }
                            />
                            {
                                filterUser.user.id || filterUser.user.name
                                    ? <div className="filter__remove" onClick={ event => {
                                        event.stopPropagation();
                                        dispatch(filterUserAction({ ...filterUser, user: { id: '', name: '' } }));
                                    } } />
                                    : false
                            }
                        </div>
                        <div className={ `dropdown__items ${ dropdown === 'filter_user' ? 'dropdown__items--open' : '' }` }>
                            {
                                filterUser.users.map(elem => {
                                    return (
                                        <div className="dropdown__item" key={ elem.id }
                                             onClick={ () => {
                                                 dispatch(filterUserAction({
                                                     ...filterUser,
                                                     user: { id: elem.id, name: elem.name }
                                                 }));
                                                 dispatch(dropdownAction(null));
                                             } }
                                        >{ `${ elem.name } ${ elem.phone }` }</div>
                                    );
                                })
                            }
                        </div>
                    </div>

                    <div className="select__wrapper">
                        <FilterSelect
                            options={ filterConstraintsOptions }
                            handler={ id => dispatch(filterConstraintsOptionsAction(filterConstraintsOptions.map(elem => {
                                // Меняем состояние выбранных элементов
                                if (elem.id === id) return { ...elem, active: !elem.active };
                                else return elem;
                            }))) }
                            placeholder={ 'Ограничение' }
                            open={ dropdown === 'filter_constraints' }
                            openHandler={ () => dispatch(dropdownAction('filter_constraints')) }
                            clear={ () => dispatch(filterConstraintsOptionsAction(filterConstraintsOptions.map(elem => {

                                if (elem.active) return { ...elem, active: !elem.active };
                                else return elem;
                            }))) }
                        />
                    </div>

                    <div className="select__wrapper">
                        <FilterSelect
                            options={ filterWorkoutsCountOptions }
                            handler={ id => dispatch(filterWorkoutsCountOptionsAction(filterWorkoutsCountOptions.map(elem => {
                                // Меняем состояние выбранных элементов
                                if (elem.id === id) return { ...elem, active: !elem.active };
                                else return elem;
                            }))) }
                            placeholder={ 'Количество занятий' }
                            open={ dropdown === 'filter_workouts_count' }
                            openHandler={ () => dispatch(dropdownAction('filter_workouts_count')) }
                            clear={ () => dispatch(filterWorkoutsCountOptionsAction(filterWorkoutsCountOptions.map(elem => {

                                if (elem.active) return { ...elem, active: !elem.active };
                                else return elem;
                            }))) }
                        />
                    </div>

                    <div className="filter__onetime">
                        <Checkbox
                            active={ filterOneTimeWorkout === '1' }
                            caption={ 'Разовое' }
                            handler={ () => dispatch(filterOneTimeWorkoutAction(filterOneTimeWorkout === '1' ? '0' : '1')) }
                        />
                    </div>
                    <div className="filter__onetime">
                        <Checkbox
                            active={ filterDebtWorkouts === '1' }
                            caption={ 'Тренировки в долг' }
                            handler={ () => dispatch(filterDebtWorkoutsAction(filterDebtWorkouts === '1' ? '0' : '1')) }
                        />
                    </div>
                    <div className="button button--blue"
                         onClick={ () => {
                             // Закрываем фильтры
                             dispatch(filterWindowAction(false));
                             // Применяем фильтры
                             dispatch(GetWorkoutsThunk({
                                 page: 1,
                                 from: filterDate.from,
                                 to: filterDate.to,
                                 subscription_type: JSON.stringify(filterTypesOptions.filter(el => el.active).map(el => el.id)),
                                 subscription_coach: JSON.stringify(filterCoachesOptions.filter(el => el.active).map(el => el.id)),
                                 subscription_constraints: JSON.stringify(filterConstraintsOptions.filter(el => el.active).map(el => el.id)),
                                 subscription_workouts_count: JSON.stringify(filterWorkoutsCountOptions.filter(el => el.active).map(el => el.id)),
                                 filter_user: filterUser.user.id,
                                 oneTime: filterOneTimeWorkout,
                                 debtWorkouts: filterDebtWorkouts
                             }));
                         } }
                    >Применить</div>
                    {
                        filterDate.from && filterDate.to
                            ?
                            <div className="button button--yellow"
                                 onClick={ () => {
                                     // Закрываем фильтры
                                     dispatch(filterWindowAction(false));

                                     dispatch(ExportWorkoutsToExcelThunk({
                                         from: filterDate.from,
                                         to: filterDate.to,
                                         subscription_type: JSON.stringify(filterTypesOptions.filter(el => el.active).map(el => el.id)),
                                         subscription_coach: JSON.stringify(filterCoachesOptions.filter(el => el.active).map(el => el.id)),
                                         subscription_constraints: JSON.stringify(filterConstraintsOptions.filter(el => el.active).map(el => el.id)),
                                         subscription_workouts_count: JSON.stringify(filterWorkoutsCountOptions.filter(el => el.active).map(el => el.id)),
                                         filter_user: filterUser.user.id,
                                         oneTime: filterOneTimeWorkout,
                                         debtWorkouts: filterDebtWorkouts
                                     }));
                                 } }
                            >Сформировать отчёт</div>
                            : false
                    }
                </div>
            </FiltersWrapper>
            <div className="button button--add"
                onClick={ () => dispatch(oneTimeWorkoutFormAction({
                    ...ONE_TIME_WORKOUT_FORM_INITIAL,
                    open: true
                })) }
            >Разовое посещение</div>
        </>
    );
};

export default WorkoutsHeader;